import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import Root from './containers/Root'
import configureStore from './store/configureStore'
// This is for Material UI
//import injectTapEventPlugin from 'react-tap-event-plugin'
//injectTapEventPlugin()

//import 'react-mdl/extra/material.css';
import 'react-mdl/extra/css/material.blue-pink.min.css';
import 'react-mdl/extra/material.js';

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js